import { createAction } from 'redux-act';

export const sendInviteEmail = createAction<object>('Send Invite Email');
export const sendInviteEmailSuccess = createAction('Send Invite Email Success');
export const sendInviteEmailFailed = createAction('Send Invite Email Failed');
